import { create } from 'zustand';
import { tenantApi } from '../services/tenant';
import type { Tenant, Subscription, UsageStats } from '../types/tenant';

interface TenantState {
  // 状态
  tenant: Tenant | null;
  subscription: Subscription | null;
  usageStats: UsageStats | null;
  isLoading: boolean;

  // Actions
  fetchTenant: () => Promise<void>;
  fetchSubscription: () => Promise<void>;
  fetchUsageStats: () => Promise<void>;
  clearTenant: () => void;
}

export const useTenantStore = create<TenantState>((set, get) => ({
  // 初始状态
  tenant: null,
  subscription: null,
  usageStats: null,
  isLoading: false,

  // 获取租户信息
  fetchTenant: async () => {
    set({ isLoading: true });
    try {
      const response = await tenantApi.getCurrentTenant();
      set({
        tenant: response.data,
        isLoading: false,
      });
    } catch (error) {
      set({ isLoading: false });
      throw error;
    }
  },

  // 获取订阅信息
  fetchSubscription: async () => {
    try {
      const response = await tenantApi.getSubscription();
      set({
        subscription: response.data,
      });
    } catch (error) {
      throw error;
    }
  },

  // 获取用量统计
  fetchUsageStats: async () => {
    try {
      const response = await tenantApi.getUsageStats();
      set({
        usageStats: response.data,
      });
    } catch (error) {
      throw error;
    }
  },

  // 清除租户信息
  clearTenant: () => {
    set({
      tenant: null,
      subscription: null,
      usageStats: null,
    });
  },
}));
